export const FILMS = [
  {
    "id": "nosferatu",
    "title": "Nosferatu",
    "year": 1922,
    "director": "F. W. Murnau",
    "category": "Horror",
    "runtime": "94 min",
    "blurb": "The vampire that started it all. An unauthorized retelling of Dracula, drenched in German Expressionist shadow.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/d363fb37567dd8e3fe7abe029c820499ac43ea8cc2fef6cfb17558c1e740ee3e.jpeg"
  },
  {
    "id": "metropolis",
    "title": "Metropolis",
    "year": 1927,
    "director": "Fritz Lang",
    "category": "Sci-Fi",
    "runtime": "153 min",
    "blurb": "A towering art-deco vision of the future where man and machine collide. The blueprint for every sci-fi city since.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/813d81a42738aa88497176393eb0b637df2529d4a7f26bcebe271775adf3fe67.jpeg"
  },
  {
    "id": "caligari",
    "title": "The Cabinet of Dr. Caligari",
    "year": 1920,
    "director": "Robert Wiene",
    "category": "Horror",
    "runtime": "76 min",
    "blurb": "Painted shadows and crooked walls. The first true psychological horror, and still one of the strangest.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/c430e3545b27d98954d3807065e90350b7b4454f4626f94a0b207d07169eb7a6.jpeg"
  },
  {
    "id": "living_dead",
    "title": "Night of the Living Dead",
    "year": 1968,
    "director": "George A. Romero",
    "category": "Horror",
    "runtime": "96 min",
    "blurb": "The film that invented the modern zombie — and accidentally fell into the public domain forever.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/56916203edf5b673a51e78c4704358992e84b075d2b5fa1628e76157893fdd3f.jpeg"
  },
  {
    "id": "trip_moon",
    "title": "A Trip to the Moon",
    "year": 1902,
    "director": "Georges Méliès",
    "category": "Sci-Fi",
    "runtime": "13 min",
    "blurb": "The rocket in the moon's eye. Cinema's first science-fiction spectacle, hand-tinted magic from 1902.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/cb63d93de9be9817033053b096706af8493100bf11af89c5423cf7b6c0371866.jpeg"
  },
  {
    "id": "carnival_souls",
    "title": "Carnival of Souls",
    "year": 1962,
    "director": "Herk Harvey",
    "category": "Horror",
    "runtime": "78 min",
    "blurb": "A dreamlike descent scored by a ghostly organ. Low-budget, high-dread, endlessly imitated.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/8115e57821c93f405919aa9156c35703cc4ff710e051fe9103487c9eb743bd2d.jpeg"
  },
  {
    "id": "phantom_opera",
    "title": "The Phantom of the Opera",
    "year": 1925,
    "director": "Rupert Julian",
    "category": "Horror",
    "runtime": "93 min",
    "blurb": "Lon Chaney's unmasking still terrifies a century later. The original opera-house nightmare.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/c36c5468e98f5267c689c60acf688693e82e4c3fb526c0632768e21bf96ca1c8.jpeg"
  },
  {
    "id": "white_zombie",
    "title": "White Zombie",
    "year": 1932,
    "director": "Victor Halperin",
    "category": "Horror",
    "runtime": "67 min",
    "blurb": "Bela Lugosi commands the walking dead on a Haitian plantation — the first feature-length zombie film.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/16788455dd3459ec01dd1462c41c21f0a53d7346ced0a0fda8fb2171d5e47fa9.jpeg"
  },
  {
    "id": "haxan",
    "title": "Häxan",
    "year": 1922,
    "director": "Benjamin Christensen",
    "category": "Horror",
    "runtime": "91 min",
    "blurb": "A part-documentary, part-fever-dream history of witchcraft that is still genuinely unsettling.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/e866d6a8ca39da7b4110c7f073f93c18d78e71679d52d9b048ddfcf9d2162b3e.jpeg"
  },
  {
    "id": "last_man_earth",
    "title": "The Last Man on Earth",
    "year": 1964,
    "director": "Ubaldo Ragona",
    "category": "Horror",
    "runtime": "86 min",
    "blurb": "Vincent Price, alone against a world of the infected. The blueprint for every apocalypse since.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/61ece4bce198da9c8f210cc405ab0b7bf3a3cf1de1259ef52cf2f84b9b1348e2.jpeg"
  },
  {
    "id": "house_haunted_hill",
    "title": "House on Haunted Hill",
    "year": 1959,
    "director": "William Castle",
    "category": "Horror",
    "runtime": "75 min",
    "blurb": "Vincent Price throws a party with a body-count. Gimmick horror at its most gleeful.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/d8c36c0853f8dd3839dcbd92b3bcc88a80ae039cbd6afab3816dc39d5d97953b.jpeg"
  },
  {
    "id": "little_shop",
    "title": "The Little Shop of Horrors",
    "year": 1960,
    "director": "Roger Corman",
    "category": "Horror",
    "runtime": "72 min",
    "blurb": "A man-eating plant, a two-day shoot, and pitch-black comedy. Corman's cult classic.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/78d1e67cb0109523d6dac87ddf6566f7905922d2fe50d53af19abdf41fac8dbe.jpeg"
  },
  {
    "id": "dementia13",
    "title": "Dementia 13",
    "year": 1963,
    "director": "Francis Ford Coppola",
    "category": "Horror",
    "runtime": "75 min",
    "blurb": "Coppola's debut: an axe-murder gothic set on a fog-bound Irish estate.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/c4b87b4119e457d4b825a34644942fded5770e3431aa8164275593d2b3bb2a91.jpeg"
  },
  {
    "id": "the_terror",
    "title": "The Terror",
    "year": 1963,
    "director": "Roger Corman",
    "category": "Horror",
    "runtime": "79 min",
    "blurb": "Boris Karloff and a young Jack Nicholson wander a haunted castle of secrets.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/623a7610f5a1a5f1ecb6bfaa73a427f31746c69a05bae5eeb68bf4a454d9ad30.jpeg"
  },
  {
    "id": "devil_bat",
    "title": "The Devil Bat",
    "year": 1940,
    "director": "Jean Yarbrough",
    "category": "Horror",
    "runtime": "68 min",
    "blurb": "Bela Lugosi breeds giant killer bats for revenge. Poverty-row mad science at its finest.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/0ffe083e15925e7ae9b5c576bbd4046696347945c7720a6d7416aa0c09780ec0.jpeg"
  },
  {
    "id": "vampire_bat",
    "title": "The Vampire Bat",
    "year": 1933,
    "director": "Frank R. Strayer",
    "category": "Horror",
    "runtime": "63 min",
    "blurb": "A superstitious village, a rash of blood-drained corpses, and Lionel Atwill's cold logic.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/628a7e41bad4cd75bb499d080dc86d90f4e30f3e152d085ba68a451c1ff5740a.jpeg"
  },
  {
    "id": "the_bat",
    "title": "The Bat",
    "year": 1959,
    "director": "Crane Wilbur",
    "category": "Horror",
    "runtime": "80 min",
    "blurb": "A masked killer stalks a mansion for hidden money. Vincent Price at his most sinister.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/bb81ea967be01a2d2c781f07152ce7fda5edba46e07315df49d1a797b3b51c45.jpeg"
  },
  {
    "id": "maniac_1934",
    "title": "Maniac",
    "year": 1934,
    "director": "Dwain Esper",
    "category": "Horror",
    "runtime": "51 min",
    "blurb": "A demented exploitation oddity about a lunatic impersonating a mad scientist. Deliriously strange.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/a5c3b02f28f79afae44dcba094f8e77a341f09509684de4ca05559ba9bada595.jpeg"
  },
  {
    "id": "screaming_skull",
    "title": "The Screaming Skull",
    "year": 1958,
    "director": "Alex Nicol",
    "category": "Horror",
    "runtime": "68 min",
    "blurb": "A widower's new bride is tormented by a skull that will not stay buried.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/c6ada26d048c099c550ce97504a37e334211ff720076e05db27c2434377be5e4.jpeg"
  },
  {
    "id": "bluebeard",
    "title": "Bluebeard",
    "year": 1944,
    "director": "Edgar G. Ulmer",
    "category": "Horror",
    "runtime": "73 min",
    "blurb": "A puppeteer in old Paris strangles the women who model for him. Moody, tragic, chilling.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/9398143c9b69efe1c9b903ceaa9d73bbc7ce0b8c230c3379db63b0f83895f267.jpeg"
  },
  {
    "id": "plan9",
    "title": "Plan 9 from Outer Space",
    "year": 1959,
    "director": "Ed Wood",
    "category": "Sci-Fi",
    "runtime": "79 min",
    "blurb": "Aliens resurrect the dead to stop humanity. Famously terrible, endlessly beloved.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/40cd476ece313e8ddc9f52296f98a76ff52d03a7357536102f0206812aaedd97.jpeg"
  },
  {
    "id": "phantom_planet",
    "title": "The Phantom Planet",
    "year": 1961,
    "director": "William Marshall",
    "category": "Sci-Fi",
    "runtime": "82 min",
    "blurb": "An astronaut shrinks to the size of the tiny aliens who capture him. Pure space-age pulp.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/d5ff826f36f4a2d77c5a9e8b20c183eb59b30467a627183cf1baf2bd2097a0b9.jpeg"
  },
  {
    "id": "teenagers_outer_space",
    "title": "Teenagers from Outer Space",
    "year": 1959,
    "director": "Tom Graeff",
    "category": "Sci-Fi",
    "runtime": "86 min",
    "blurb": "Alien youths bring 'gargon' monsters to Earth. Ray-gun skeletons and drive-in glory.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/7d30dbdc7242e98435b4934c0fa28dc05c71cee991b149b637fbf74adedbc5ea.jpeg"
  },
  {
    "id": "first_spaceship_venus",
    "title": "First Spaceship on Venus",
    "year": 1960,
    "director": "Kurt Maetzig",
    "category": "Sci-Fi",
    "runtime": "78 min",
    "blurb": "An international crew journeys to a dead Venusian civilization. Lush Eastern-bloc sci-fi.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/3f449ad1d51e11695b321468f9d9b83ac3c4cfcd0655cf3b43c3de56b168d2c8.jpeg"
  },
  {
    "id": "wasp_woman",
    "title": "The Wasp Woman",
    "year": 1959,
    "director": "Roger Corman",
    "category": "Sci-Fi",
    "runtime": "73 min",
    "blurb": "A cosmetics queen's youth serum turns her into a murderous half-insect. Corman schlock gold.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/7d7fa6eb80c92c6eb9127d8cf64045f31ac421c97e428479e06de7440c1ac68e.jpeg"
  },
  {
    "id": "giant_leeches",
    "title": "Attack of the Giant Leeches",
    "year": 1959,
    "director": "Bernard L. Kowalski",
    "category": "Sci-Fi",
    "runtime": "62 min",
    "blurb": "Something enormous lurks in the swamp, dragging victims under. Grimy, gloopy creature feature.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/70c9336c0630d9fda0d6e47e995978597a2849aeeffb9280aba652292cc34f2f.jpeg"
  },
  {
    "id": "amazing_transparent",
    "title": "The Amazing Transparent Man",
    "year": 1960,
    "director": "Edgar G. Ulmer",
    "category": "Sci-Fi",
    "runtime": "58 min",
    "blurb": "A crook turned invisible by a mad scientist decides to rob the world blind.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/e181d503db98a69820202cf29f40127bcfd276b0643f033c4c58f0d17a606262.jpeg"
  },
  {
    "id": "beyond_time_barrier",
    "title": "Beyond the Time Barrier",
    "year": 1960,
    "director": "Edgar G. Ulmer",
    "category": "Sci-Fi",
    "runtime": "75 min",
    "blurb": "A test pilot rockets into a plague-ravaged future. Angular, low-budget time-travel noir.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/6c7cc5478d319262a451b939dcbcc3cf83ffa1f40cd3fb819e198c9e65a24abf.jpeg"
  },
  {
    "id": "lost_world_1925",
    "title": "The Lost World",
    "year": 1925,
    "director": "Harry O. Hoyt",
    "category": "Sci-Fi",
    "runtime": "106 min",
    "blurb": "Willis O'Brien's stop-motion dinosaurs stomp through the original creature epic — pre-King Kong.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/d6cf78347c7ab04a12a90062a11fa9223e7176bc65c8689eaff6a30972f74c80.jpeg"
  },
  {
    "id": "santa_martians",
    "title": "Santa Claus Conquers the Martians",
    "year": 1964,
    "director": "Nicholas Webster",
    "category": "Sci-Fi",
    "runtime": "81 min",
    "blurb": "Martians kidnap Santa to bring joy to their gloomy children. Gloriously, cheerfully absurd.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/bddec245c835ae25854c2b40a80a4205461582763d1b182284a3a1d4666290a2.jpeg"
  },
  {
    "id": "killer_shrews",
    "title": "The Killer Shrews",
    "year": 1959,
    "director": "Ray Kellogg",
    "category": "Sci-Fi",
    "runtime": "69 min",
    "blurb": "Scientists trapped on an island by giant venomous shrews — played by dogs in costumes. A cult riot.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/49f8a33e96a982835052682e602d25a59ac5ffb5201cdbc0d3f4ad6d4b2908f4.jpeg"
  },
  {
    "id": "voyage_prehistoric_women",
    "title": "Voyage to the Planet of Prehistoric Women",
    "year": 1968,
    "director": "Peter Bogdanovich",
    "category": "Sci-Fi",
    "runtime": "78 min",
    "blurb": "Recut Soviet space footage plus telepathic Venusian sirens. Strange, dreamy, one-of-a-kind.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/26b6c62c3cfca08b0b819a0243143876ef1ed80204eb3da1b2469aa434afd3ff.jpeg"
  },
  {
    "id": "jekyll_hyde_1920",
    "title": "Dr. Jekyll and Mr. Hyde",
    "year": 1920,
    "director": "John S. Robertson",
    "category": "Horror",
    "runtime": "49 min",
    "blurb": "John Barrymore's astonishing transformation, done live on camera. The definitive silent Jekyll.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/0831a0c1da3cd44a85a9dc7d0d59f403fd4de139ef5b2c8dd33951264cb887c0.jpeg"
  },
  {
    "id": "golem_1920",
    "title": "The Golem",
    "year": 1920,
    "director": "Paul Wegener",
    "category": "Horror",
    "runtime": "76 min",
    "blurb": "A clay giant is brought to life to protect a ghetto — and turns on its makers. Expressionist myth.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/0f82d47f24e3f6bc3df8bbf1a207915c492d4f22bc36860e4cb6688aa4dfac55.jpeg"
  },
  {
    "id": "hunchback_1923",
    "title": "The Hunchback of Notre Dame",
    "year": 1923,
    "director": "Wallace Worsley",
    "category": "Horror",
    "runtime": "133 min",
    "blurb": "Lon Chaney's tragic Quasimodo, buried under pounds of makeup. Grand, grotesque, unforgettable.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/2ade7dafe047c8c54612dfadf638f04ec9e5d105dddcf9534f4f114c7ba6a0a8.jpeg"
  },
  {
    "id": "cat_canary_1927",
    "title": "The Cat and the Canary",
    "year": 1927,
    "director": "Paul Leni",
    "category": "Horror",
    "runtime": "82 min",
    "blurb": "A midnight will-reading in an old dark house. The blueprint for every haunted-mansion whodunit.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/ffe128e1ace676b09d7b4b404018d7f0e74558501403f9540d8b5118495459a7.jpeg"
  },
  {
    "id": "bat_whispers",
    "title": "The Bat Whispers",
    "year": 1930,
    "director": "Roland West",
    "category": "Horror",
    "runtime": "83 min",
    "blurb": "A caped master criminal terrorizes a mansion — a visual feast that inspired Batman himself.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/6c29396cc3bb43037b0e1df1cceb59daff2ad398bca2b90cadd698f7f90f68bf.jpeg"
  },
  {
    "id": "corpse_vanishes",
    "title": "The Corpse Vanishes",
    "year": 1942,
    "director": "Wallace Fox",
    "category": "Horror",
    "runtime": "64 min",
    "blurb": "Bela Lugosi steals brides at the altar to keep his wife young. Deliriously macabre poverty-row pulp.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/1805cfe78eacc4b6ef7a5fff4c65e96e4e8b0fe13bcc416b85c7de7bbdfc2be8.jpeg"
  },
  {
    "id": "ape_man",
    "title": "The Ape Man",
    "year": 1943,
    "director": "William Beaudine",
    "category": "Horror",
    "runtime": "64 min",
    "blurb": "A scientist's experiment leaves him half-ape and hungry for spinal fluid. Lugosi at his gnarliest.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/bcee6c337202045050001cc20023622053414ca08bb217a166c2aed3fa5a656c.jpeg"
  },
  {
    "id": "king_zombies",
    "title": "King of the Zombies",
    "year": 1941,
    "director": "Jean Yarbrough",
    "category": "Horror",
    "runtime": "67 min",
    "blurb": "A plane crashes on an island ruled by a zombie-raising doctor. Wartime spook-show fun.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/2ede1e2603ea6e25825018f394a18bb3659dd57046f38804c718580edf02de24.jpeg"
  },
  {
    "id": "the_gorilla_1939",
    "title": "The Gorilla",
    "year": 1939,
    "director": "Allan Dwan",
    "category": "Horror",
    "runtime": "66 min",
    "blurb": "The Ritz Brothers, a killer on the loose, and an actual gorilla in a shadowy mansion. Old-dark-house comedy.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/a6b4d543807584ac565d6411086b1abda55a1642e5422b76a7750e45a654ff34.jpeg"
  },
  {
    "id": "beast_yucca",
    "title": "The Beast of Yucca Flats",
    "year": 1961,
    "director": "Coleman Francis",
    "category": "Horror",
    "runtime": "54 min",
    "blurb": "A defecting scientist mutates into a killer after an atomic blast. So-bad-it's-legendary.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/bf8fc552f44cc6185a93cf432ca659c1704075d499fc9fbb7d651449283dc38f.jpeg"
  },
  {
    "id": "atom_age_vampire",
    "title": "Atom Age Vampire",
    "year": 1960,
    "director": "Anton Giulio Majano",
    "category": "Horror",
    "runtime": "87 min",
    "blurb": "A scientist restores a scarred woman's beauty by murdering others for their glands. Italian gothic sci-fi.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/1abc5003dc8981eee32a4704294d50a9d01d65aae67d6ba1094241f9395baefe.jpeg"
  },
  {
    "id": "nightmare_castle",
    "title": "Nightmare Castle",
    "year": 1965,
    "director": "Mario Caiano",
    "category": "Horror",
    "runtime": "90 min",
    "blurb": "Barbara Steele haunts a cruel husband who murdered her. Lush, cobwebbed Italian gothic dread.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/69410a7860863cbb31b3c67143c59c1f6f5e4b521ff3ff4387cf698ae63ebbd0.jpeg"
  },
  {
    "id": "monster_maker",
    "title": "The Monster Maker",
    "year": 1944,
    "director": "Sam Newfield",
    "category": "Horror",
    "runtime": "62 min",
    "blurb": "A mad doctor infects a rival with disfiguring acromegaly out of obsession. Grim little chiller.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/7fb1518b66fa1820d7995bf4b52871fb7bc3e372dde4d9a7c9cc592d17c9530d.jpeg"
  },
  {
    "id": "indestructible_man",
    "title": "Indestructible Man",
    "year": 1956,
    "director": "Jack Pollexfen",
    "category": "Horror",
    "runtime": "70 min",
    "blurb": "An executed criminal is revived, bulletproof and out for revenge. Lon Chaney Jr. seethes.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/0678bfdc87b5701d417e6701ddeab2a87371acde368e36a08ff6eafef67f1500.jpeg"
  },
  {
    "id": "snow_creature",
    "title": "The Snow Creature",
    "year": 1954,
    "director": "W. Lee Wilder",
    "category": "Sci-Fi",
    "runtime": "70 min",
    "blurb": "An expedition captures a Yeti and ships it to Los Angeles — where it escapes. The first Yeti feature.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/e528860777b0b105adca06bcbfb33a5b4327a08d1b2a14a3528de9c1e6bc0bff.jpeg"
  },
  {
    "id": "assignment_outer_space",
    "title": "Assignment: Outer Space",
    "year": 1960,
    "director": "Antonio Margheriti",
    "category": "Sci-Fi",
    "runtime": "73 min",
    "blurb": "A reporter joins a crew racing to stop a runaway spaceship. Colorful Italian space opera.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/a9ebb6b2f59617605a4a9837e9d17d6a1c9936180b57fd72b6cc71975474a267.jpeg"
  },
  {
    "id": "phantom_creeps",
    "title": "The Phantom Creeps",
    "year": 1939,
    "director": "Ford Beebe",
    "category": "Sci-Fi",
    "runtime": "78 min",
    "blurb": "Bela Lugosi as a mad inventor with a giant robot and an invisibility belt. Vintage serial mayhem.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/b1213fd2668a742f88855cdfadbbb2d23f103da8d88a7393332122c67ead0695.jpeg"
  },
  {
    "id": "she_gods_shark",
    "title": "She Gods of Shark Reef",
    "year": 1958,
    "director": "Roger Corman",
    "category": "Sci-Fi",
    "runtime": "63 min",
    "blurb": "Two brothers wash up on an island of pearl-diving women and an angry idol. Corman exotica.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/633e02e684c9ed935be31bb838704248f4fa58c439b0d3ecc105d21d4ce98b2d.jpeg"
  },
  {
    "id": "mesa_lost_women",
    "title": "Mesa of Lost Women",
    "year": 1953,
    "director": "Ron Ormond",
    "category": "Sci-Fi",
    "runtime": "70 min",
    "blurb": "A scientist breeds giant spiders and spider-women in the desert. Feverish, flamenco-scored oddity.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/2a0f510cbecab156775fd3a44f2df42abbca697eecef86da5d474e7c90591162.jpeg"
  },
  {
    "id": "gamma_people",
    "title": "The Gamma People",
    "year": 1956,
    "director": "John Gilling",
    "category": "Sci-Fi",
    "runtime": "79 min",
    "blurb": "Reporters stumble on a dictator turning children into geniuses and zombies with gamma rays.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/d9b9a81baf3ef2eadb429a5e6ec644463267f6a846a15075f70ca4a736ee1ca9.jpeg"
  },
  {
    "id": "warning_from_space",
    "title": "Warning from Space",
    "year": 1956,
    "director": "Koji Shima",
    "category": "Sci-Fi",
    "runtime": "87 min",
    "blurb": "Starfish-shaped aliens warn Earth of a coming collision. Japan's first color sci-fi feature.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/3a018a8a0cd79b7808b0656f5dd61860bd7de38c1ef2698800d51aae30ce34ea.jpeg"
  },
  {
    "id": "most_dangerous_game",
    "title": "The Most Dangerous Game",
    "year": 1932,
    "director": "Irving Pichel & E. B. Schoedsack",
    "category": "Horror",
    "runtime": "63 min",
    "blurb": "A big-game hunter shipwrecks on an island where a mad count hunts humans for sport.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/8f15488a1b4977aa6c4f1cb9e6a5a6286fd6e81204ce3d5339a93c3dbf6d8749.jpeg"
  },
  {
    "id": "vampyr",
    "title": "Vampyr",
    "year": 1932,
    "director": "Carl Theodor Dreyer",
    "category": "Horror",
    "runtime": "73 min",
    "blurb": "Dreyer's hypnagogic vampire nightmare — all drifting shadows, gauze and dread.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/93242fd5005106746bdfbfd243ca6ca0ee2c58672ef4c4b6d55674328dd16d27.jpeg"
  },
  {
    "id": "the_monster_1925",
    "title": "The Monster",
    "year": 1925,
    "director": "Roland West",
    "category": "Horror",
    "runtime": "86 min",
    "blurb": "Lon Chaney as a deranged doctor luring motorists into his sanitarium of horrors.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/8f7ee8cfad9c4a183af6d04e473bdd07242d36c5521a8030041b325cafa6bc0c.jpeg"
  },
  {
    "id": "city_of_the_dead",
    "title": "City of the Dead",
    "year": 1960,
    "director": "John Llewellyn Moxey",
    "category": "Horror",
    "runtime": "76 min",
    "blurb": "A student researches witchcraft in a fog-bound New England town that never let its coven die.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/40a22171560e8ea652a75cc946ccbe16db058dbf0fcd11f2d2cfb4a33fbb4d7a.jpeg"
  },
  {
    "id": "tormented_1960",
    "title": "Tormented",
    "year": 1960,
    "director": "Bert I. Gordon",
    "category": "Horror",
    "runtime": "75 min",
    "blurb": "A jazz pianist lets his lover fall to her death — and her vengeful ghost won't stay drowned.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/f5829c18d733530f17ffa3cb657d6d309b8d901962a44d4a5eaed76066da8e7c.jpeg"
  },
  {
    "id": "the_sadist",
    "title": "The Sadist",
    "year": 1963,
    "director": "James Landis",
    "category": "Horror",
    "runtime": "95 min",
    "blurb": "Stranded travelers at the mercy of a giggling spree killer in a sun-blasted junkyard.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/b684128c046863e1c7eea4f5cb55aec3b24434ee8d2c2530be4e661b0414bb47.jpeg"
  },
  {
    "id": "voodoo_man",
    "title": "Voodoo Man",
    "year": 1944,
    "director": "William Beaudine",
    "category": "Horror",
    "runtime": "62 min",
    "blurb": "Bela Lugosi abducts women to revive his dead wife through voodoo. Poverty-row delirium.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/dc1a19d5b1f5fc5e113e6523e36d1ee1885f29ffadde5a5e61bb7ff578b51c95.jpeg"
  },
  {
    "id": "dead_men_walk",
    "title": "Dead Men Walk",
    "year": 1943,
    "director": "Sam Newfield",
    "category": "Horror",
    "runtime": "64 min",
    "blurb": "A murdered occultist rises as a vampire to destroy the twin brother who killed him.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/01d89a70f71b824f7f1d3b78015ff09b3c7707f981bb42e444377b21555bcf56.jpeg"
  },
  {
    "id": "the_mad_monster",
    "title": "The Mad Monster",
    "year": 1942,
    "director": "Sam Newfield",
    "category": "Horror",
    "runtime": "77 min",
    "blurb": "A scientist turns his simple handyman into a werewolf brute for revenge.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/4187b47c1c9638864cd6628e24afdb119d820c13191ea18dce6f179e73d180a7.jpeg"
  },
  {
    "id": "revolt_of_the_zombies",
    "title": "Revolt of the Zombies",
    "year": 1936,
    "director": "Victor Halperin",
    "category": "Horror",
    "runtime": "65 min",
    "blurb": "An expedition seeks the secret of raising an unstoppable undead army in Cambodia.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/24426aceec721d6719819e2a4e2e988e1d7663bc3d8023c3327d92af660a1fc5.jpeg"
  },
  {
    "id": "scared_to_death",
    "title": "Scared to Death",
    "year": 1947,
    "director": "Christy Cabanne",
    "category": "Horror",
    "runtime": "65 min",
    "blurb": "Narrated by its own corpse, a lurid color chiller of hypnotists and hidden killers.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/269bee9cb4ae1678eca3cd3e494222c26a847c3a2a7be91a4a08af7f850f6dac.jpeg"
  },
  {
    "id": "fog_island",
    "title": "Fog Island",
    "year": 1945,
    "director": "Terry O. Morse",
    "category": "Horror",
    "runtime": "72 min",
    "blurb": "An ex-con lures his betrayers to a fog-wrapped island mansion for deadly revenge.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/a7d8943f74fdc5dae8d0114b746dc6c09b2a58f6ffec28664ce41707447f98e6.jpeg"
  },
  {
    "id": "the_amazing_mr_x",
    "title": "The Amazing Mr. X",
    "year": 1948,
    "director": "Bernard Vorhaus",
    "category": "Horror",
    "runtime": "78 min",
    "blurb": "A silky fake spiritualist preys on a grieving widow. Gorgeous noir-horror shadows.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/b698f997de55219036e635520d8caee32186d7a744be3a084625f6eed4db8b59.jpeg"
  },
  {
    "id": "the_ghoul_1933",
    "title": "The Ghoul",
    "year": 1933,
    "director": "T. Hayes Hunter",
    "category": "Horror",
    "runtime": "73 min",
    "blurb": "Boris Karloff as a dying Egyptologist who vows to rise from the tomb for revenge.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/e78c18aed2b7112763a7dc3905e35ef20693c64e36883a5da5d707551536ae11.jpeg"
  },
  {
    "id": "the_bat_1926",
    "title": "The Bat",
    "year": 1926,
    "director": "Roland West",
    "category": "Horror",
    "runtime": "86 min",
    "blurb": "A bat-masked jewel thief terrorizes a mansion full of suspects. The silent original.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/e7eaec5e930088932fb83b4c3c8c1348480d47207efeb8b6e69bed1560b41af9.jpeg"
  },
  {
    "id": "usher_1928",
    "title": "The Fall of the House of Usher",
    "year": 1928,
    "director": "James Sibley Watson",
    "category": "Horror",
    "runtime": "13 min",
    "blurb": "An avant-garde American take on Poe — prisms, distortion, and a house that devours itself.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/33a91c1d40cc8e59ecd8017f9f698b4530dfc0c0b881b69ec9c32bbb83cf7d9b.jpeg"
  },
  {
    "id": "missile_to_the_moon",
    "title": "Missile to the Moon",
    "year": 1958,
    "director": "Richard E. Cunha",
    "category": "Sci-Fi",
    "runtime": "78 min",
    "blurb": "Escaped convicts pilot a rocket to the moon and find rock-men and a society of women.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/477f79b40bd5f59093fb5a7d8272b7b7c808a7bd2844912d2952ea84d81b06fd.jpeg"
  },
  {
    "id": "night_of_the_blood_beast",
    "title": "Night of the Blood Beast",
    "year": 1958,
    "director": "Bernard L. Kowalski",
    "category": "Sci-Fi",
    "runtime": "65 min",
    "blurb": "An astronaut returns from orbit dead — and impregnated by an alien organism.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/7d9f26533b2cc234aace0af69fc43130e54857724af80474fd936f49d2557d8c.jpeg"
  },
  {
    "id": "wild_women_of_wongo",
    "title": "The Wild Women of Wongo",
    "year": 1958,
    "director": "James L. Wolcott",
    "category": "Sci-Fi",
    "runtime": "72 min",
    "blurb": "A prehistoric fable of beautiful women, handsome men, and a crocodile god. Camp exotica.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/344e5fcedf1c4701541b8362a00cdccddf113d45cf6bc1773209aa884027454c.jpeg"
  },
  {
    "id": "prehistoric_women_1950",
    "title": "Prehistoric Women",
    "year": 1950,
    "director": "Gregg C. Tallas",
    "category": "Sci-Fi",
    "runtime": "74 min",
    "blurb": "A tribe of women who've sworn off men must reckon with fire, giants and desire.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/1b6ef26490406fce7eb4189ee3e6c2933aa997dadce046f3527f12f3e441d35d.jpeg"
  },
  {
    "id": "battle_beyond_sun",
    "title": "Battle Beyond the Sun",
    "year": 1959,
    "director": "Mikhail Karyukov",
    "category": "Sci-Fi",
    "runtime": "75 min",
    "blurb": "A re-cut Soviet epic (by a young Coppola) of rival nations racing rockets to Mars.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/6e030cda3230d7cbc5f04741d4e44bb75f41053a28199f80c6913f4c891d6f25.jpeg"
  },
  {
    "id": "the_lost_missile",
    "title": "The Lost Missile",
    "year": 1958,
    "director": "Lester Wm. Berke",
    "category": "Sci-Fi",
    "runtime": "70 min",
    "blurb": "A runaway missile circles Earth at 4,000°, incinerating everything in its path.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/28a0f695146f2beae919004aa8e8597d7886371731526eb2b33a851fc8cb6668.jpeg"
  },
  {
    "id": "cosmos_war_planets",
    "title": "Cosmos: War of the Planets",
    "year": 1977,
    "director": "Alfonso Brescia",
    "category": "Sci-Fi",
    "runtime": "89 min",
    "blurb": "A rogue computer and a tentacled alien menace a crew in this disco-era space romp.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/3362b89c30366060bbee697e1a8fa07a539e0eb6edc432342fc08fb546d72a28.jpeg"
  },
  {
    "id": "frankenstein_1910",
    "title": "Frankenstein",
    "year": 1910,
    "director": "J. Searle Dawley",
    "category": "Horror",
    "runtime": "13 min",
    "blurb": "Edison's 1910 one-reeler — the very first Frankenstein film, conjuring the monster from a cauldron of chemical fire.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/fea4bddccbf9437c28a3bf40d3509b37bef4bac493913e719af5a6ddc43df2fe.jpeg"
  },
  {
    "id": "svengali_1931",
    "title": "Svengali",
    "year": 1931,
    "director": "Archie Mayo",
    "category": "Horror",
    "runtime": "81 min",
    "blurb": "John Barrymore hypnotizes a young singer into stardom and obsession, in a fever-dream of Expressionist sets and hollow eyes.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/3987d57d2aca8273948c5f0acbf13ffb80f8ddefbee6375a88b20c0faf7d192b.jpeg"
  },
  {
    "id": "killers_from_space",
    "title": "Killers from Space",
    "year": 1954,
    "director": "W. Lee Wilder",
    "category": "Sci-Fi",
    "runtime": "71 min",
    "blurb": "A scientist returns from the dead with bulging alien eyes and a warning: bug-eyed invaders are massing beneath the desert.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/8e7ddc4cc73def6f9e75e3a2c0810f1b70f0a2bab949c33d45951d786ddd2d0f.jpeg"
  },
  {
    "id": "planet_outlaws",
    "title": "Planet Outlaws",
    "year": 1953,
    "director": "Ford Beebe",
    "category": "Sci-Fi",
    "runtime": "69 min",
    "blurb": "Buck Rogers wakes 500 years in the future to battle the tyrant Killer Kane — the Buck Rogers serial recut for the atomic age.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/a7a1968ff71be64592d46c540f4e6d43e54f499b8a00eb6ed988608cd6094803.jpeg"
  },
  {
    "id": "in_the_year_2889",
    "title": "In the Year 2889",
    "year": 1967,
    "director": "Larry Buchanan",
    "category": "Sci-Fi",
    "runtime": "80 min",
    "blurb": "Survivors of nuclear apocalypse huddle in a poisoned valley as mutants close in. Corman's Last Woman on Earth, remade in lurid color.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/e4de85a861cb97e9330d80b3e75a14e55826e48ef243b321c738aac36aba7c8b.jpeg"
  },
  {
    "id": "things_to_come",
    "title": "Things to Come",
    "year": 1936,
    "director": "William Cameron Menzies",
    "category": "Sci-Fi",
    "runtime": "95 min",
    "blurb": "H.G. Wells scripts a century of war, plague and rebirth into a gleaming machine-age utopia. Still the grandest vision of the future ever built.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/26ac7d33719688bd8021d9cdc5bdebc7af65210ba6f22dad9a29a3997b86d583.jpeg"
  },
  {
    "id": "unknown_world",
    "title": "Unknown World",
    "year": 1951,
    "director": "Terry O. Morse",
    "category": "Sci-Fi",
    "runtime": "74 min",
    "blurb": "Fearing the bomb, scientists drill a great mole-machine to the center of the Earth in search of a refuge for humankind.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/a096dfdaa41e19b90b0787d56b747bbb53d0c382c3155eca7ae271d757bf0fe8.jpeg"
  },
  {
    "id": "phantom_from_space",
    "title": "Phantom from Space",
    "year": 1953,
    "director": "W. Lee Wilder",
    "category": "Sci-Fi",
    "runtime": "72 min",
    "blurb": "An invisible alien crash-lands near Los Angeles and is hunted through the observatory it wandered into. Cold, strange, and quiet.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/acacd983bf1f669a50d669408c1f261546b6ae98c568ed88ab063ce95e27cea9.jpeg"
  },
  {
    "id": "the_atomic_man",
    "title": "The Atomic Man",
    "year": 1955,
    "director": "Ken Hughes",
    "category": "Sci-Fi",
    "runtime": "77 min",
    "blurb": "A man pulled from a river is radioactive and answers questions seconds before they're asked — living a few ticks ahead of time.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/5934b5f4f018b73097568d41da08a3dd5c4a09ac13c9aa51229710b21e753c12.jpeg"
  },
  {
    "id": "the_eye_creatures",
    "title": "The Eye Creatures",
    "year": 1965,
    "director": "Larry Buchanan",
    "category": "Sci-Fi",
    "runtime": "76 min",
    "blurb": "Blob-eyed aliens land near a lovers' lane while the Army watches through the wrong end of every telescope. Gloriously threadbare.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/c8537cdb6d0abcec4b7b60f32f2d2c9cf6412de3526e511bd0245059784bbf37.jpeg"
  },
  {
    "id": "this_is_not_a_test",
    "title": "This Is Not a Test",
    "year": 1962,
    "director": "Fredric Gadette",
    "category": "Sci-Fi",
    "runtime": "72 min",
    "blurb": "A lawman holds strangers at a lonely roadblock as the nuclear countdown airs on the radio. A tense chamber piece at the end of the world.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/221656819dbeb30305dd6243828811bfe680006b5b26d8ce4b9b5af5222751fb.jpeg"
  },
  {
    "id": "last_woman_on_earth",
    "title": "Last Woman on Earth",
    "year": 1960,
    "director": "Roger Corman",
    "category": "Sci-Fi",
    "runtime": "72 min",
    "blurb": "Two men and one woman surface from a dive to find the air has briefly stopped — and everyone else is dead. Scripted by Robert Towne.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/b4330bf4820af04ea0a82d725493c583b25e201078bc9e13f725a312fc1ca0a6.jpeg"
  },
  {
    "id": "flash_gordon_conquers",
    "title": "Flash Gordon Conquers the Universe",
    "year": 1940,
    "director": "Ford Beebe",
    "category": "Sci-Fi",
    "runtime": "19 min",
    "blurb": "Flash duels Ming the Merciless over the fate of Earth in the last and wildest of the rocket-sparking serials.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/30b636f8fff4a8113c76a4ea081d9104aa1e9c7f23166d758a414cdff0d44df2.jpeg"
  },
  {
    "id": "transatlantic_tunnel",
    "title": "Transatlantic Tunnel",
    "year": 1935,
    "director": "Maurice Elvey",
    "category": "Sci-Fi",
    "runtime": "82 min",
    "blurb": "An engineer sacrifices decades and a marriage to bore a tunnel beneath the ocean, in a sleek Deco dream of progress.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/c8a690a73b7fc2e090715276d6576d99250fe841fee70650dca3baff28e8eee7.jpeg"
  },
  {
    "id": "crash_of_the_moons",
    "title": "Rocky Jones: Crash of the Moons",
    "year": 1954,
    "director": "Hollingsworth Morse",
    "category": "Sci-Fi",
    "runtime": "72 min",
    "blurb": "Space Ranger Rocky Jones races to save a doomed world as two moons hurtle toward collision. Vintage TV space opera on the big screen.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/3b4af7cbddb5fd72d6e8e37de4d444ae0321dbc1830068f1263b8205efc546f3.jpeg"
  },
  {
    "id": "attack_from_space",
    "title": "Attack from Space",
    "year": 1959,
    "director": "Teruo Ishii",
    "category": "Sci-Fi",
    "runtime": "76 min",
    "blurb": "The atomic superhero Starman defends Earth from the invaders of the Sperians — Japanese serial thrills chopped into a feature.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/9548914e168eb850797b40dd1617c74750793d10667c61519e34a18b85ee33c8.jpeg"
  },
  {
    "id": "cat_women_of_the_moon",
    "title": "Cat-Women of the Moon",
    "year": 1953,
    "director": "Arthur Hilton",
    "category": "Sci-Fi",
    "runtime": "64 min",
    "blurb": "A rocket crew discovers a dying race of telepathic women in black leotards ruling the lunar dark side. 3-D pulp at its purest.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/5e4ea00feb64a3e1eaedb1f71561c9a604767bc772451017920f521dacfd71d8.jpeg"
  },
  {
    "id": "project_moonbase",
    "title": "Project Moonbase",
    "year": 1953,
    "director": "Richard Talmadge",
    "category": "Sci-Fi",
    "runtime": "63 min",
    "blurb": "A 1970 where a woman is President and a sabotaged rocket strands two officers on the Moon. Co-written by Robert A. Heinlein.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/c4fc15f35fdf36ec9ce13412dd2a444b2b7b0ff6b1edf27dc3e031cc172e99ec.jpeg"
  },
  {
    "id": "the_creeping_terror",
    "title": "The Creeping Terror",
    "year": 1964,
    "director": "Vic Savage",
    "category": "Sci-Fi",
    "runtime": "77 min",
    "blurb": "A carpet-shaggy alien monster inches across California devouring the slow-footed, while a narrator explains the missing soundtrack. Legendarily bad.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/96ac453af3c056c0c08bf070d8c1b38a1459e7bd2f4f6daa6fe02db6783be3c1.jpeg"
  },
  {
    "id": "eegah",
    "title": "Eegah",
    "year": 1962,
    "director": "Arch Hall Sr.",
    "category": "Sci-Fi",
    "runtime": "90 min",
    "blurb": "A prehistoric giant thawed in the desert falls for a teenager and crashes a pool party. Watch for the shaving scene.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/4b90ed8caa85843aba9939f12c36a83cba588d180146dd9f23a80128c32525ce.jpeg"
  },
  {
    "id": "the_phantom_empire",
    "title": "The Phantom Empire",
    "year": 1935,
    "director": "Otto Brower",
    "category": "Sci-Fi",
    "runtime": "69 min",
    "blurb": "Singing cowboy Gene Autry stumbles onto the underground super-science kingdom of Murania. The strangest western-sci-fi serial ever made.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/84438b452f1dbeab343c09d43de306a081de72227bd94ab2e44f784a472b60fa.jpeg"
  },
  {
    "id": "the_day_the_sky_exploded",
    "title": "The Day the Sky Exploded",
    "year": 1958,
    "director": "Paolo Heusch",
    "category": "Sci-Fi",
    "runtime": "80 min",
    "blurb": "A runaway rocket knocks a swarm of asteroids toward Earth. Italy's first sci-fi film, scored by Ennio Morricone.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/c3e1f020004687f3d64ba6da038a99fe4c7f7bf12c423505ed5586c980866af4.jpeg"
  },
  {
    "id": "robot_monster",
    "title": "Robot Monster",
    "year": 1953,
    "director": "Phil Tucker",
    "category": "Sci-Fi",
    "runtime": "63 min",
    "blurb": "Ro-Man — a gorilla suit under a diving helmet — has wiped out humanity save for one family. A poem of ambition and bubble machines.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/782876e85329845f44ec3ff48195f02a85257ff21c02be8f923793b43d994a93.jpeg"
  },
  {
    "id": "disorder_in_the_court",
    "title": "Disorder in the Court",
    "year": 1936,
    "director": "Preston Black",
    "category": "Comedy",
    "runtime": "17 min",
    "blurb": "The Three Stooges take the witness stand and reduce a murder trial to rubble. One of the immortal public-domain Stooge shorts.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/276bc834685c593b7b6df0b46df9faf05b63ee60d4ae428e11aafec822ff0507.jpeg"
  },
  {
    "id": "malice_in_the_palace",
    "title": "Malice in the Palace",
    "year": 1949,
    "director": "Jules White",
    "category": "Comedy",
    "runtime": "16 min",
    "blurb": "Moe, Larry and Shemp chase a stolen diamond across a cartoon Middle East. Peak Stooge chaos, forever in the public domain.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/c1639fc5fdb07c039c33a41ca008e843712c6827e7e2682f399aaaf3ae62adc3.jpeg"
  },
  {
    "id": "sing_a_song_of_six_pants",
    "title": "Sing a Song of Six Pants",
    "year": 1947,
    "director": "Jules White",
    "category": "Comedy",
    "runtime": "17 min",
    "blurb": "The Stooges run a failing tailor shop and accidentally nab a bank robber in the trousers. Slapstick tailoring at its finest.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/6551ff027f6f40e224285e3c13e133db39a6e7b6f1829420ee903c938aa08e78.jpeg"
  },
  {
    "id": "brideless_groom",
    "title": "Brideless Groom",
    "year": 1947,
    "director": "Edward Bernds",
    "category": "Comedy",
    "runtime": "17 min",
    "blurb": "Shemp must marry within hours to inherit a fortune, and every woman in town suddenly wants him. A Stooge classic in the commons.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/309fc4baba90511b8220802c5978bb061913ec732dbffcce7ba408662eed8994.jpeg"
  },
  {
    "id": "three_little_beers",
    "title": "Three Little Beers",
    "year": 1935,
    "director": "Del Lord",
    "category": "Comedy",
    "runtime": "17 min",
    "blurb": "Delivery-men Stooges crash a golf tournament and destroy a beer garden along the way. Curly at full tilt.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/04567f9ca46b9e0ffa7037c26b4a661fbdd95c32944c6799762cd8fc54c2777d.jpeg"
  },
  {
    "id": "his_girl_friday",
    "title": "His Girl Friday",
    "year": 1940,
    "director": "Howard Hawks",
    "category": "Comedy",
    "runtime": "92 min",
    "blurb": "Cary Grant's editor schemes to keep his ace reporter ex-wife from remarrying by burying her in one last story. Dialogue at machine-gun speed.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/6d50dc63b60e53156668647fa61030cdc057d725b9864ad711164a10aecce551.jpeg"
  },
  {
    "id": "my_favorite_brunette",
    "title": "My Favorite Brunette",
    "year": 1947,
    "director": "Elliott Nugent",
    "category": "Comedy",
    "runtime": "87 min",
    "blurb": "Bob Hope, a baby photographer mistaken for a private eye, tangles with Dorothy Lamour and a gang of crooks. A perfect noir spoof.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/d04874cf179b9dc057e60f078c9038fc88740b13ea25001dd05e0c585b48aee8.jpeg"
  },
  {
    "id": "the_flying_deuces",
    "title": "The Flying Deuces",
    "year": 1939,
    "director": "A. Edward Sutherland",
    "category": "Comedy",
    "runtime": "68 min",
    "blurb": "Laurel and Hardy join the Foreign Legion to mend a broken heart and promptly get sentenced to the firing squad.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/e9570cd8f703614b02851a4e8e3aa87c9596a35fb6fb757804ea16726ada8bdf.jpeg"
  },
  {
    "id": "africa_screams",
    "title": "Africa Screams",
    "year": 1949,
    "director": "Charles Barton",
    "category": "Comedy",
    "runtime": "79 min",
    "blurb": "Abbott and Costello bumble into an African safari chasing a treasure map. Lions, cannibals, and perfect vaudeville panic.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/4eb1a38d118ff225a269b7ab24bedd1976d5e06d696421db6da536dea799648f.jpeg"
  },
  {
    "id": "jack_and_the_beanstalk",
    "title": "Jack and the Beanstalk",
    "year": 1952,
    "director": "Jean Yarbrough",
    "category": "Comedy",
    "runtime": "82 min",
    "blurb": "Abbott and Costello retell the fairy tale in Technicolor, with Lou as Jack climbing to a giant's castle in the clouds.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/b5adcdb87294db3e315e72c5aa3a677371c5a20e92e3efe541f7bca76c12c1a9.jpeg"
  },
  {
    "id": "at_war_with_the_army",
    "title": "At War with the Army",
    "year": 1950,
    "director": "Hal Walker",
    "category": "Comedy",
    "runtime": "91 min",
    "blurb": "Dean Martin and Jerry Lewis stumble through basic training in their first star vehicle. Pure early Martin-and-Lewis mayhem.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/8fa6d2f83f448bf50c977a46434186e7e49ae8a85ebe2bf91c9d35d6de7aec20.jpeg"
  },
  {
    "id": "mr_robinson_crusoe",
    "title": "Mr. Robinson Crusoe",
    "year": 1932,
    "director": "A. Edward Sutherland",
    "category": "Comedy",
    "runtime": "76 min",
    "blurb": "Douglas Fairbanks bets he can survive a desert island with nothing — and builds a bachelor paradise. Athletic silent-era charm with sound.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/341e7e6ead6d086e5b825370868e57cb632a68f42b2508635dfb87315f8de9f4.jpeg"
  },
  {
    "id": "mclintock",
    "title": "McLintock!",
    "year": 1963,
    "director": "Andrew V. McLaglen",
    "category": "Comedy",
    "runtime": "127 min",
    "blurb": "John Wayne's cattle baron wrangles a runaway wife and a mud-brawling town. A big, boisterous Western farce.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/8fbe5d860c9264643de5af7487683745dd9082a280f78bcc3f493176b673d477.jpeg"
  },
  {
    "id": "behave_yourself",
    "title": "Behave Yourself!",
    "year": 1951,
    "director": "George Beck",
    "category": "Comedy",
    "runtime": "81 min",
    "blurb": "A married couple's stray dog is wanted by three rival gangs of killers. A screwball crime comedy with Shelley Winters.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/f725d35fac3ad658d951fa4174cecbd9c2212f9aba234cd78cb07771a463ea84.jpeg"
  },
  {
    "id": "angel_on_my_shoulder",
    "title": "Angel on My Shoulder",
    "year": 1946,
    "director": "Archie Mayo",
    "category": "Comedy",
    "runtime": "101 min",
    "blurb": "A murdered gangster cuts a deal with the Devil to return to Earth in a judge's body. A wicked fantasy-comedy with Paul Muni.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/85885d1b0349f00934237db58b223d9458a10e4bc4e23f54d8437c8d61ae940d.jpeg"
  },
  {
    "id": "the_amazing_adventure",
    "title": "The Amazing Adventure",
    "year": 1936,
    "director": "Alfred Zeisler",
    "category": "Comedy",
    "runtime": "62 min",
    "blurb": "A bored millionaire (Cary Grant) bets he can live a year on his own earnings — and falls for his boss's secretary.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/2e3f1023772f0c1a95f5bf81d8c6ded7970ed3794f8759479e5f1337da5aa520.jpeg"
  },
  {
    "id": "mush_and_milk",
    "title": "Mush and Milk",
    "year": 1933,
    "director": "Robert F. McGowan",
    "category": "Comedy",
    "runtime": "20 min",
    "blurb": "The Our Gang kids scheme to rescue their broke boarding-school from a stern headmistress. Little Rascals warmth and anarchy.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/db511cfd8f284ce7cf22eab5b9603d68fc406c27df9dbd1110fa8ae1bb5d5464.jpeg"
  },
  {
    "id": "west_of_hot_dog",
    "title": "West of Hot Dog",
    "year": 1924,
    "director": "Scott Pembroke",
    "category": "Comedy",
    "runtime": "30 min",
    "blurb": "Stan Laurel, solo and silent, inherits a saloon in a lawless town and spends two reels dodging bullets. Pre-Hardy slapstick gold.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/9e37f2f0af86ec8bd8f2259ca69d1b0e71cf232c88f6104cb8b70af81f7e1dcf.jpeg"
  },
  {
    "id": "the_general",
    "title": "The General",
    "year": 1927,
    "director": "Buster Keaton",
    "category": "Comedy",
    "runtime": "67 min",
    "blurb": "Buster Keaton chases his stolen locomotive — and his sweetheart — through the Civil War. The greatest silent comedy ever built.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/a82339a4ad768b2059980103c7dd592440a7777acee9c90fef64beeb59064501.jpeg"
  },
  {
    "id": "keaton_cops",
    "title": "Cops",
    "year": 1922,
    "director": "Buster Keaton",
    "category": "Comedy",
    "runtime": "18 min",
    "blurb": "Buster accidentally provokes an entire city police force and outruns them in a two-reel ballet of catastrophe.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/fae69895d42772eb342d3431c40cf226766b9105152989c3e9db2ee359554864.jpeg"
  },
  {
    "id": "the_goat",
    "title": "The Goat",
    "year": 1921,
    "director": "Buster Keaton",
    "category": "Comedy",
    "runtime": "23 min",
    "blurb": "Mistaken for a killer, Buster is chased across town by cops, crooks, and fate itself. Twenty perfect minutes of misfortune.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/6e8af4e19bfc1693bd037a871ba73f843a3a6c27e791fdc301bc2d11d9c0b012.jpeg"
  },
  {
    "id": "chaplin_festival",
    "title": "Charlie Chaplin Festival",
    "year": 1917,
    "director": "Charlie Chaplin",
    "category": "Comedy",
    "runtime": "80 min",
    "blurb": "Four immortal Chaplin two-reelers — including The Immigrant and The Adventurer — that made the Tramp the most famous man on Earth.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/465212ad9473c3152a31edf0b9a6543e59008f44f4a2819e7c43a2b01213268c.jpeg"
  },
  {
    "id": "a_bucket_of_blood",
    "title": "A Bucket of Blood",
    "year": 1959,
    "director": "Roger Corman",
    "category": "Comedy",
    "runtime": "65 min",
    "blurb": "A busboy becomes the toast of the beatnik art scene by sculpting over the bodies he keeps making. Corman's pitch-black comedy, shot in five days.",
    "poster": "https://static.prod-images.emergentagent.com/jobs/86fb1679-d749-4b31-9538-591f84a31f12/images/7adcb19349e9f391557dbf72b5607c9b8a9a9033fc2318e41eb3a489d96c81a9.jpeg"
  }
];

export const CHAPTERS = [
  {
    "n": "01",
    "title": "Curated from the commons",
    "body": "Every title has fully entered the public domain. No rights holders, no restrictions, no expiry dates. Cinema that belongs to everyone."
  },
  {
    "n": "02",
    "title": "Restored for the dark",
    "body": "We scan the cleanest surviving prints, wash out the scratches, and preserve the grain that makes them feel alive. The way they were meant to be seen."
  },
  {
    "n": "03",
    "title": "Two dollars a month",
    "body": "No bundles, no upsells, no free-trial trap that quietly renews at $19.99. One flat price — cheaper than a coffee — for the entire archive. Cancel anytime."
  },
  {
    "n": "04",
    "title": "Own the night",
    "body": "Stream it, download it, remix it, screen it at your own midnight showing. These films are yours as much as ours."
  }
];
